// DEPRECATED: CancelToken
// https://github.com/axios/axios/tree/2e70cecda42993e1153248f0f96715c3c55f7f39#canceltoken-deprecated

export const createCancellableState = (state) => ({
  cancelToken: null,

  ...state
})
